export enum ToolsType {
  DRAW_POLYGON = "draw_polygon",
  EDIT_POLYGON = "edit_polygon",
  NONE = "none",
}
